import { View, StyleSheet } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";
import AdminCompanionDocumentCard, { DocumentData } from "../AdminCompanionDocumentCard/AdminCompanionDocumentCard";

interface AdminCompanionDocumentCardListProps {
  documents: DocumentData[];
  onDelete?: (id: string) => void;
}

function AdminCompanionDocumentCardList({ documents, onDelete }: AdminCompanionDocumentCardListProps) {
  if (documents.length === 0) {
    return null;
  }

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <CustomText
          text={`Uploaded Documents (${documents.length})`}
          size="s"
          weight="bold"
          useTranslationText={false}
          style={styles.title}
        />
      </View>

      <View style={styles.list}>
        {documents.map((document) => (
          <AdminCompanionDocumentCard key={document.id} document={document} onDelete={onDelete} />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  title: {
    color: "#101828",
  },
  list: {
    gap: 8,
  },
});

export default AdminCompanionDocumentCardList;
